import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './FindDealerForm.css';

const emptyForm = { name: '', phone: '', city: '' };

function FindDealerForm() {
    const [formData, setFormData] = useState(emptyForm);
    const [status, setStatus] = useState(null); // 'success' | 'error' | 'invalid-phone' | null
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formattedPhone = formData.phone.startsWith('+') ? formData.phone : `+${formData.phone}`;
        if (!/^\+?[1-9]\d{7,14}$/.test(formattedPhone)) {
            setStatus('invalid-phone');
            return;
        }

        setIsSubmitting(true);
        try {
            // TODO: switch to a dedicated find-dealer endpoint once the backend has one
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-contact-form`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formData.name,
                    phone: formattedPhone,
                    city: formData.city,
                    purpose: 'Find A Dealer',
                    message: `Find A Dealer request - City / Area: ${formData.city}`,
                }),
            });

            const result = await response.json();
            if (result.success) {
                setStatus('success');
                setFormData(emptyForm);
            } else {
                setStatus('error');
            }
        } catch (err) {
            console.error(err);
            setStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className="find-dealer-container">
            <h1 className="find-dealer-title">Find A Dealer</h1>
            <p className="find-dealer-subtitle">Fill out the form to find a nearby showroom in your city.</p>

            <form className="find-dealer-form" onSubmit={handleSubmit}>
                <label htmlFor="dealer-name">Name*</label>
                <input
                    type="text"
                    id="dealer-name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />

                <label htmlFor="dealer-phone">Mobile Number*</label>
                <PhoneInput
                    country={'in'}
                    enableSearch={true}
                    value={formData.phone}
                    onChange={(phone) => setFormData({ ...formData, phone })}
                    inputProps={{ id: 'dealer-phone', required: true }}
                    inputClass="find-dealer-phone-input"
                    containerClass="find-dealer-phone-container"
                />

                <label htmlFor="dealer-city">City / Area*</label>
                <input
                    type="text"
                    id="dealer-city"
                    required
                    value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                />

                {status === 'success' && (
                    <p className="find-dealer-msg success">Thank you! Our team will contact you shortly.</p>
                )}
                {status === 'invalid-phone' && (
                    <p className="find-dealer-msg error">Please enter a valid phone number.</p>
                )}
                {status === 'error' && (
                    <p className="find-dealer-msg error">Something went wrong. Please try again.</p>
                )}

                <button type="submit" className="find-dealer-submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
        </section>
    );
}

export default FindDealerForm;
